module.exports = __webpack_public_path__ + "static/media/agriminer-consultant.b9b0d5c6.jpg";